import ThreeColumn from "./ThreeColumn";

export default ThreeColumn;
